import { render, staticRenderFns } from "./Programari_viitoare.vue?vue&type=template&id=2d5da659&scoped=true&"
import script from "./Programari_viitoare.vue?vue&type=script&lang=js&"
export * from "./Programari_viitoare.vue?vue&type=script&lang=js&"
import style0 from "./Programari_viitoare.vue?vue&type=style&index=0&id=2d5da659&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5da659",
  null
  
)

export default component.exports